/**
 * System Information created/updated timestamps (matches UserDetails).
 * Example: "24 May 2026, 3:45 pm" (Malaysia time)
 */
import { MALAYSIA_TZ } from './malaysiaTime';

export function formatSystemDateTime(value) {
  if (value == null || value === '') return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleString('en-MY', {
    timeZone: MALAYSIA_TZ,
    dateStyle: 'medium',
    timeStyle: 'short',
  });
}
